// Announcement bar on mobile: every message stays on one line (sections/announcement-bar.liquid, assets/custom.css).
// A message wider than the bar gets .is-marquee and scrolls to its end and back, instead of wrapping onto a second line
// and making the whole bar taller. The distance is measured per message, so short messages stay centred and still.

const MOBILE = window.matchMedia('(max-width: 699px)');
const SPEED = 30; // px per second while moving

const measure = (list) => {
  list.querySelectorAll(':scope > *').forEach((message) => {
    const text = message.querySelector('p');
    if (!text) return;

    message.classList.remove('is-marquee');

    if (MOBILE.matches && text.offsetWidth - message.clientWidth > 1) {
      // Measured again with the class on: it adds the side padding the faded edges need
      message.classList.add('is-marquee');
      const distance = Math.ceil(text.offsetWidth - message.clientWidth);

      // The keyframes hold still for 30% of the time (15% at each end), so the moving part runs at SPEED
      const duration = Math.max(4, distance / SPEED / 0.7);
      message.style.setProperty('--marquee-distance', `${distance}px`);
      message.style.setProperty('--marquee-duration', `${duration.toFixed(2)}s`);
    }
  });
};

const setup = (root = document) => {
  root.querySelectorAll('.announcement-bar__message-list').forEach((list) => {
    if (list.dataset.marquee) return;
    list.dataset.marquee = 'true';

    new ResizeObserver(() => measure(list)).observe(list);
    document.fonts?.ready.then(() => measure(list));
  });
};

setup();
document.addEventListener('shopify:section:load', (event) => setup(event.target));
